/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_Inspiration_DescInputs */

const en_site_relation_inspiration_desc = /** @type {(inputs: Site_Relation_Inspiration_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A site you admire`)
};

const id_site_relation_inspiration_desc = /** @type {(inputs: Site_Relation_Inspiration_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs yang kamu kagumi`)
};

/**
* | output |
* | --- |
* | "A site you admire" |
*
* @param {Site_Relation_Inspiration_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_inspiration_desc = /** @type {((inputs?: Site_Relation_Inspiration_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_Inspiration_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_inspiration_desc(inputs)
	return en_site_relation_inspiration_desc(inputs)
});